import { getPermissions, getActionsForProgram } from "../utils/secureStorage";
import { 
  getRouteForProgram, 
  getDashboardForUser, 
  ROUTE_CONFIG 
} from "../config/routeConfig";

export const getRoleBasedNavigationLink = (programCode, menuCode, userRole, entityType = null) => {
  const normalizedProgramCode = programCode?.toUpperCase();
  const normalizedRole = userRole?.toUpperCase();
  const normalizedEntityType = entityType?.toUpperCase();
  const normalizedMenuCode = menuCode?.toUpperCase();

  const userActions = getActionsForProgram(normalizedProgramCode);

  // Use entityType first for route lookup, fallback to role
  const lookupKey = normalizedEntityType || normalizedRole;
  const route = getRouteForProgram(normalizedProgramCode, lookupKey, normalizedEntityType, userActions);
  if (route) return route;

  if (ROUTE_CONFIG[normalizedProgramCode]?.DEFAULT) {
    return ROUTE_CONFIG[normalizedProgramCode].DEFAULT;
  }

  return `/${normalizedMenuCode?.toLowerCase()}/${programCode?.toLowerCase()}`;
};

export const getDashboardPath = (userRole, entityType = null) => {
  const permissions = getPermissions();
  return getDashboardForUser(userRole, entityType, permissions);
};
